import TileLayer from 'ol/layer/Tile';
import { WMTS } from 'ol/source';
import WMTSTileGrid from 'ol/tilegrid/WMTS';
import { get as getProjection, transformExtent } from 'ol/proj';
import { getTopLeft, getWidth } from 'ol/extent';

export function createSatelliteLayer(visible: boolean): TileLayer<WMTS> {
  const matrixSet = '3857_20';
  const format = 'image/jpeg';
  const style = 'default';
  const dimensions = { Time: 'current' } as any;

  const projection = getProjection('EPSG:3857');
  if (!projection) throw new Error('EPSG:3857 projection not found');

  const fullExtent = projection.getExtent()!;
  const tileSize = 256;
  const baseResolution = getWidth(fullExtent) / tileSize;

  const maxZoom = 20;
  const resolutions: number[] = [];
  const matrixIds: string[] = [];
  for (let z = 0; z <= maxZoom; z++) {
    resolutions[z] = baseResolution / Math.pow(2, z);
    matrixIds[z] = z.toString();
  }

  const wgs84Bbox = [5.140242, 45.398181, 11.47757, 48.230651];
  const extent3857 = transformExtent(wgs84Bbox as any, 'EPSG:4326', 'EPSG:3857');

  const tileGrid = new WMTSTileGrid({
    origin: getTopLeft(fullExtent),
    resolutions,
    matrixIds,
    tileSize,
    extent: extent3857,
  });

  return new TileLayer({
    source: new WMTS({
      url: 'https://wmts.geo.admin.ch/1.0.0/ch.swisstopo.swissimage/default/{Time}/3857/{TileMatrix}/{TileCol}/{TileRow}.jpeg',
      layer: 'ch.swisstopo.swissimage',
      matrixSet,
      format,
      style,
      dimensions,
      tileGrid,
      wrapX: true,
      requestEncoding: 'REST',
    }),
    visible,
  });
} 